import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { unitMapping } from '@sorare/core/src/lib/style';
import { roundLastChild } from '@sorare/core/src/style/utils';

const Root = styled(Horizontal).attrs({ center: true })`
  background: var(--footer-bg-color);
  transition: background-color 0.3s ease-in-out;
  color: var(--color, var(--c-nd-700));

  &:not(.noPadding) {
    padding: 0 var(--half-unit);
  }

  ${roundLastChild}
`;

type Props = {
  children: ReactNode;
  height?: keyof typeof unitMapping;
  noPadding?: boolean;
  className?: string;
};
export const BasicBenchExtraWrapper = ({
  children,
  height = 2.5,
  noPadding,
  className,
}: Props) => {
  return (
    <Root
      className={classNames(className, { noPadding })}
      center
      style={{ height: unitMapping[height] }}
    >
      {children}
    </Root>
  );
};
